import { defineComponent as _defineComponent } from 'vue'
import { nanoid } from 'nanoid'
import { twMerge } from 'tailwind-merge'
import { computed, inject, provide } from 'vue'
import { storeToRefs } from 'pinia'

import { useCommandStore } from './useCommandStore'
import { groupOptionsInjectionKey, optionsInjectionKey } from './utils'

interface CommandGroupProps {
  heading?: string
  twClass?: string
  excludeFromFilter?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CommandGroup',
  props: {
    heading: null,
    twClass: null,
    excludeFromFilter: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  heading?: string
  twClass?: string
  excludeFromFilter?: boolean
};



const { shouldFilter, storeId } = inject(optionsInjectionKey, {
  shouldFilter: true,
  storeId: '',
})

const commandStore = useCommandStore(storeId)
const { filtered, isSearching } = storeToRefs(commandStore)

const groupId = `cmd-group-${nanoid()}`

provide(groupOptionsInjectionKey, {
  groupId,
  excludeFromFilter: props.excludeFromFilter,
})

const shouldRender = computed(() => {
  if (!shouldFilter || props.excludeFromFilter) {
    return true
  }
  return !isSearching.value ? true : filtered.value.groups.includes(groupId)
})

return { __sfc: true,props, shouldFilter, storeId, commandStore, filtered, isSearching, groupId, shouldRender, twMerge }
}

})